import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../../core/services/translation.service';
import { getDaysFromTime, getTimeFormat } from '../../core/utils/time.utils';

@Pipe({
  name: 'time'
})
export class TimePipe implements PipeTransform {
  constructor(private translationService: TranslationService) { }

  transform(time: number, format: string = '{HOURS}:{MINS}:{SECS}', nullText = '0', limitToShowInDays: number | false = false): any {
    return (time !== null) ? this.transformTime(time, format, limitToShowInDays) : nullText;
  }

  private transformTime(time: number, format: string, limitToShowInDays: number | false) {
    return (!limitToShowInDays || time < limitToShowInDays)
      ? getTimeFormat(format, time)
      : this.getTimeInDays(time);
  }

  private getTimeInDays(time: number) {
    const days = getDaysFromTime(time);

    return this.translationService.getTranslationSync('shared.time.days', { days });
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/pipes/time.pipe.ts